

  <nz-form-item>
    <nz-form-label [nzSpan]="24">
      NCSP
    </nz-form-label>
    <nz-form-control [nzSpan]="24" >
      <nz-tree-select
        [nzNodes]="classificationCodeService.classificationNCSPCodes()"
        nzShowSearch
        nzPlaceHolder="Please select"
        nzVirtualHeight="300px"
        nzHideUnMatched="true"
        nzCheckStrictly="true"
        nzShowLine="true"
        nzSize="large"
        nzMultiple="true"
        [(ngModel)]="selectedNCSPIds"
        (ngModelChange)="onNCSPChange($event)"
      ></nz-tree-select>
    </nz-form-control>
  </nz-form-item>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modalRef.triggerCancel()">
    <i nz-icon nzType="close"></i>
    <span>გაუქმება</span>
  </button>
  <button nz-button nzType="primary" (click)="submit()">
    <i nz-icon nzType="save"></i>
    <span>შენახვა</span>
  </button>
</div>

